export default __webpack_public_path__ + "static/media/ben-konfrst.bbe72dc4.jpg";